import { render } from "./payment-noop.vue?vue&type=template&id=13776812&scoped=true"
import script from "./payment-noop.vue?vue&type=script&lang=js"
export * from "./payment-noop.vue?vue&type=script&lang=js"

import "./payment-noop.vue?vue&type=style&index=0&id=13776812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13776812"]])

export default __exports__